/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import ReservationEvent from '../../event/ReservationEvent'

const CalendarState = Record({
  active: false,
  search: false
})

class ReservationCalendarStore extends ReduceStore<State, Action> {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new CalendarState()
  }

  reduce(state, action) {
    switch (action.type) {
      case ReservationEvent.showDetail:
        return state.merge({ active: true })

      case ReservationEvent.hideDetail:
        return state.merge({ active: false })

      case ReservationEvent.editCancel:
        return state.merge({ active: true })

      default:
        return state
    }
  }
}

export default new ReservationCalendarStore()
